import { render, staticRenderFns } from "./PopupLayout.vue?vue&type=template&id=0b6ff29e"
import script from "./PopupLayout.ts?vue&type=script&lang=ts&external"
export * from "./PopupLayout.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports